/**
 * Values that represent "no cover" selection in PersonalisedCoverQuestion.
 *
 * - '0': Numeric "no cover" option (takes priority)
 * - 'no'/'Not required' etc.: Alternative "no cover" option
 * - '': Empty string (no selection made)
 */
const NO_COVER_VALUES = [
  "0",
  "no",
  "",
  "Not required",
  "Neither cover is required",
] as const;
type NoCoverValue = (typeof NO_COVER_VALUES)[number];

export const isNoCoverValue = (value: unknown): value is NoCoverValue =>
  NO_COVER_VALUES.includes(value as NoCoverValue);
